import { NgModule } from '@angular/core';
import { OvGenericModule } from '@ov-suite/ui';
import { InventoryLocation } from '@ov-suite/models-admin';

@NgModule({
  imports: [
    OvGenericModule.forRoot({
      entity: InventoryLocation,
      api: 'adminlink',
      createTitle: 'Inventory Location',
      route: ['inventory-location'],
      tableTitle: 'Inventory Locations',
      tabs: [
        {
          path: '/factory',
          title: 'Factories & Warehouses',
        },
        {
          path: '/factory-area',
          title: 'Factory Area',
        },
        {
          path: '/inventory-location',
          title: 'Inventory Location',
        },
      ],
      permissionId: 904,
    }),
  ],
})
export class InventoryLocationModule {}
